import { api } from '../lib/api';
import { useFetch } from '../lib/useFetch';
import { fmtBR, fmtMoney } from '../lib/format';
import type { PageProps } from '../App';

const TIPO_LABEL: Record<string, string> = {
  emprestimo: 'Empréstimo', integralizacao: 'Integralização', aporte: 'Aporte',
  devolucao_emprestimo: 'Dev. empréstimo', devolucao_aporte: 'Dev. aporte',
  aplicacao: 'Aplicação', resgate: 'Resgate',
};

export function Aportes(_: PageProps) {
  const data = useFetch(async () => {
    const [aportes, aplic, socios] = await Promise.all([
      api.listAportes(),
      api.listAplicacoes(),
      api.listSocios().catch(() => ({ items: [] })),
    ]);
    const nome = new Map<number, string>(socios.items.map((s) => [s.id, s.nome] as [number, string]));
    return {
      aportes: aportes.items.map((a) => ({ ...a, socioNome: a.socio ?? nome.get(a.socio_id) ?? `Sócio ${a.socio_id}` })),
      aplic: aplic.items,
    };
  }, []);

  const aportesTotal = (data.data?.aportes ?? []).reduce((s, a) => s + a.valor, 0);
  const aplicTotal = (data.data?.aplic ?? []).reduce((s, a) => s + (a.tipo === 'resgate' ? -a.valor : a.valor), 0);

  return (
    <div className="page mid">
      <h1 style={{ marginBottom: 20 }}>Aportes &amp; Aplicações</h1>
      {data.loading ? (
        <div className="loading">Carregando…</div>
      ) : (
        <div className="grid-2">
          <div className="tbl">
            <div className="card-head">Aportes de sócios · total {fmtMoney(aportesTotal)}</div>
            {(data.data?.aportes.length ?? 0) === 0 ? <div className="loading">Sem aportes.</div> :
              data.data!.aportes.map((a) => (
                <div className="tbl-row" key={a.id} style={{ display: 'flex', gap: 10 }}>
                  <span className="mono text-sm muted">{fmtBR(a.data)}</span>
                  <span style={{ flex: 1, fontWeight: 500 }} className="ellipsis">{a.socioNome}</span>
                  <span className="chip-sq neutral">{TIPO_LABEL[a.tipo] ?? a.tipo}</span>
                  <span className="mono cell-strong">{fmtMoney(a.valor)}</span>
                </div>
              ))}
          </div>
          <div className="tbl">
            <div className="card-head">Aplicações financeiras · saldo aplicado {fmtMoney(aplicTotal)}</div>
            {(data.data?.aplic.length ?? 0) === 0 ? <div className="loading">Sem aplicações.</div> :
              data.data!.aplic.map((a) => (
                <div className="tbl-row" key={a.id} style={{ display: 'flex', gap: 10 }}>
                  <span className="mono text-sm muted">{fmtBR(a.data)}</span>
                  <span style={{ flex: 1, fontWeight: 500 }} className="ellipsis">{a.produto}</span>
                  <span className={`chip-sq ${a.tipo === 'resgate' ? 'suggest' : 'neutral'}`}>{TIPO_LABEL[a.tipo] ?? a.tipo}</span>
                  <span className="mono cell-strong">{fmtMoney(a.valor)}</span>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
